import { toDateObject, adjustFormat } from "util/DateTime";
const toUTCFrequencyTime = (time = "", timezone = "UTC") => {
  const [hours, minutes] = time.split(":");
  const localDateTime = toDateObject(/* @__PURE__ */ new Date(), void 0, timezone != null ? timezone : "UTC").hours(Number(hours)).minutes(Number(minutes));
  return adjustFormat(localDateTime, "hourAndMinute", "UTC");
};
export default toUTCFrequencyTime;
